import Lottie from 'lottie-react';
import { cn } from '@/lib/utils';
import successAnimation from '@/pages/assets/animations/success-animation.json';

interface AnimatedCheckmarkProps {
    className?: string;
    loop?: boolean;
}

export default function AnimatedCheckmark({ className, loop = false }: AnimatedCheckmarkProps) {
    return (
        <Lottie animationData={successAnimation} loop={loop} className={cn('w-8 h-8', className)} />
    );
}
